import $ from "jquery";

const $input = $("footer .wpcf7-form-control-wrap .wpcf7-form-control");
let originalPlaceholder = "";
let lessThan500 = false;
let greaterThan500 = false;

$(window).on("load", () => {
    originalPlaceholder = $input.attr("placeholder");
});

// Run when window is resized
$(window).on("resize load", (event) => {
    const $this = $(event.currentTarget);
    if ($this.width() < 500) {
        console.log("less than 500px");
        if (lessThan500) {
            return;
        } else {
            lessThan500 = true;
            greaterThan500 = false;
            $input.attr("placeholder", "Enter Email");
        }
    } else {
        console.log("greater than 500px");
        if (greaterThan500) {
            return;
        } else {
            greaterThan500 = true;
            lessThan500 = false;
            $input.attr("placeholder", originalPlaceholder);
        }
    }
});
